import { BASE_URL } from "../../Api/ApiUrls";

/**
 * Bank Auction upload limit check
 * - user_type = "Bank Auction"
 * - Uses auction-property API with user_id filter
 */
export const checkBankAuctionUploadLimit = async (userId) => {
  try {
    /* --------------------------------
       1. FETCH SUBSCRIPTIONS
    -------------------------------- */
    const subRes = await fetch(`${BASE_URL}/Get-user-plan/${userId}/`);
    if (!subRes.ok) {
      return {
        canUpload: false,
        reason: "NO_SUBSCRIPTION",
        message: "Please take a Bank Auction subscription",
      };
    }

    const subscriptions = await subRes.json();

    const bankAuctionPlans = subscriptions.filter(
      (p) => p.user_type === "Bank Auction"
    );

    if (bankAuctionPlans.length === 0) {
      return {
        canUpload: false,
        reason: "NO_SUBSCRIPTION",
        message: "Please take a Bank Auction subscription",
      };
    }

    /* --------------------------------
       2. FETCH USER BANK AUCTIONS (✅ FIX)
    -------------------------------- */
    const auctionRes = await fetch(
      `${BASE_URL}/auction-property/?user_id=${userId}`
    );

    if (!auctionRes.ok) {
      return {
        canUpload: false,
        reason: "ERROR",
        message: "Unable to verify auction properties",
      };
    }

    const userAuctions = await auctionRes.json();
    const usedCount = Array.isArray(userAuctions)
      ? userAuctions.length
      : 0;

    /* --------------------------------
       3. CALCULATE LIMIT
    -------------------------------- */
    let totalLimit = 0;
    let unlimited = false;

    bankAuctionPlans.forEach((plan) => {
      if (plan.no_of_properties_unlimited) {
        unlimited = true;
      } else {
        totalLimit += Number(plan.no_of_properties || 0);
      }
    });

    /* --------------------------------
       4. FINAL DECISION
    -------------------------------- */
    if (unlimited) {
      return {
        canUpload: true,
        remaining: "Unlimited",
      };
    }

    if (usedCount < totalLimit) {
      return {
        canUpload: true,
        remaining: totalLimit - usedCount,
      };
    }

    return {
      canUpload: false,
      reason: "LIMIT_EXCEEDED",
      message: "You have reached your Bank Auction upload limit",
      remaining: 0,
    };
  } catch (error) {
    console.error("Bank auction limit error:", error);
    return {
      canUpload: false,
      reason: "ERROR",
      message: "Something went wrong while checking subscription",
    };
  }
};
